export default [{
  mainButton: {
    name: 'vacancyAdd',
    label: 'Add',
    goTo: '?modal=vacancy-editor~-1',
    tooltip: 'Add new vacancy'
  }
}, {
  mainButton: {
    name: 'vacancyFiltersOutsourcing',
    label: 'Outsourcing<br>company',
    tooltip: 'Vacancies filter by outsourcing companies',
    customMenuComponent: 'vacancyFiltersOutsourcing'
  }
}, {
  mainButton: {
    name: 'vacancyFiltersWorkType',
    label: 'Types of work',
    tooltip: 'Filter vacancies by type of work',
    customMenuComponent: 'vacancyFiltersWorkType'
  }
}, {
  mainButton: {
    name: 'vacancyFiltersFree',
    label: 'Free',
    tooltip: 'Filter vacancies by status: free / not free',
    menu: [{
      name: 'selectAll',
      label: 'All vacancies',
      goTo: '?vacancyFilterFree=all'
    }, {
      name: 'vacanciesFree',
      label: 'Free only',
      goTo: '?vacancyFilterFree=free'
    }, {
      name: 'vacanciesNotFree',
      label: 'Employed only',
      goTo: '?vacancyFilterFree=not-free'
    }]
  }
}, {
  mainButton: {
    name: 'vacancyFiltersApproved',
    label: 'Confirmed',
    tooltip: 'Filter vacancies by status: confirmed / not confirmed',
    menu: [{
      name: 'selectAll',
      label: 'All vacancies',
      goTo: '?vacancyFilterApproved=all'
    }, {
      name: 'vacanciesFree',
      label: 'Confirmed only',
      goTo: '?vacancyFilterApproved=approved'
    }, {
      name: 'vacanciesNotFree',
      label: 'Unconfirmed only',
      goTo: '?vacancyFilterApproved=not-approved'
    }]
  }
}, {
  mainButton: {
    name: 'includeOutsource',
    label: 'Outsourcing<br>exchange ',
    tooltip: 'Enable / disable showing jobs from other networks ',
    goTo: '?includeOutsource=TOGGLE'
  }
}, {
  mainButton: {
    name: 'internalExchange',
    label: 'Internal<br>exchange ',
    tooltip: 'Enabling / disabling the display of vacancies on the internal exchange',
    goTo: '?internalExchange=TOGGLE'
  }
}, {
  mainButton: {
    name: 'selectInternalOrOutsources',
    label: 'Select the order<br>from whom',
    goTo: '?modal=selectInternalOrOutsources'
  }
}];